import { Route } from '@angular/router'
import { CAcademyComponent } from './c-academy.component'
import { CAcademyFormationComponent } from './c-academy-formation/c-academy-formation.component'

export const C_ACADEMY_ROUTES: Route[] = [
    {path: '', component: CAcademyComponent},
    {path: ':id', component: CAcademyFormationComponent},
];